// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { useQuery, type UseQueryResult } from 'react-query'

import { Template } from '@/services/tcc/configurator'
import { EMPTY_TEMPLATE_ID, getTemplates } from '@/services/templates'

export const queryKey = ['GetTemplates']

export const useGetTemplates = (): UseQueryResult<Template[], Error> => {
  return useQuery(queryKey, async () => {
    const templates = await getTemplates()

    return templates.filter((template) => template.id !== EMPTY_TEMPLATE_ID)
  })
}
